import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import { ENDPOINTS } from "utils/endpoints";
import { fetchPageContent } from "../DownloadAndDelete/actions";
import { setA11yContent } from "../NavigationHelper/actions";

import Header from "common-components/Header";
import CommonContainer from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";

class BECustomer extends Component {
  state = {
    loading: true,
    title: "",
    desc: ""
  };

  componentDidMount() {
    this.props.fetchPageContent(ENDPOINTS.FETCH_BE_CUSTOMER_PAGE).then(() => {
      this.setState({ loading: false });
      if (checkNestedObject(this.props.pageContent, "becustomer", "sc_pagetitle")) {
        this.setState({
          title: this.props.pageContent.becustomer.richText[0].title,
          desc: this.props.pageContent.becustomer.richText[0].description
        });
        this.props.setA11yContent("account not supported", this.props.pageContent.becustomer.sc_pagetitle);
      }
    });
  }

  render() {
    if (this.state.loading) {
      return <RectangleLoader />;
    }

    return (
      <Container>
        <Fragment>
          <Header style={{ maxWidth: "515px" }}>{this.state.title}</Header>
          <p style={{ marginTop: "24px", maxWidth: "381px" }}>{this.state.desc}</p>
        </Fragment>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent }) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { fetchPageContent, setA11yContent }
)(BECustomer);

const Container = styled(CommonContainer)`
  margin: 0;
  padding: 80px 20px 440px 20px;

  ${media.mobile`
    padding: 48px 16px 100px 16px;
  `}
`;
